import { TOGGLE_PMR_CHECKBOX } from 'Store/booking/additional-accommodations/additionalAccommodations.action';
type State = boolean;
const initialState: State = false;
export function isPmrChecked(state: State = initialState, action: Action<any>): State {
  switch (action.type) {
    case TOGGLE_PMR_CHECKBOX:
      return action.payload.isChecked;

    default:
      return state;
  }
}
